import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import React from "react";
import { connect } from "react-redux";
import { getListofStatusQuery } from "../../../services/graphql/queries/masters";
import queryString from "query-string";
class StatusList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: "",
      statusData: []
    };
  }

  getStatus() {
    this.props.client
      .query({
        query: getListofStatusQuery,
        variables: {
          statusFor: queryString.parse(this.props.location.search).id
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const statusData = result.data.getListofStatus;

        this.setState({ statusData: statusData, loading: false, error: "" });
      })
      .catch(error => {
        this.setState({ loading: false, error: error.message });
      });
  }

  componentDidMount() {
    this.getStatus();
  }
  render() {
    const { loading, error, statusData } = this.state;
    return (
      <>
        <div className="row align-items-center no-gutters">
          <div className="col-md-7">
            <h1 className="heading m-b-0">{`${
              queryString.parse(this.props.location.search).name
            } List`}</h1>
          </div>
        </div>
        <table className="table table-style-1 ">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            {statusData.length
              ? statusData.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td>{data.statusId} </td>
                      <td>{data.name} </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </table>
        {!statusData.length && error ? <div>Error !!!</div> : null}
        {!statusData.length && loading ? <div>Fetching...</div> : null}
        {!statusData.length && !error && !loading ? (
          <div style={{ textAlign: "center" }}>No Data</div>
        ) : null}
      </>
    );
  }
}

export default withRouter(connect()(withApollo(StatusList)));
